import linkedin from '../../img/linkedin-logo.webp';
import instagram from '../../img/instagram-logo.webp';
import facebook from '../../img/facebook-logo.webp';
import tiktok from '../../img/tiktok-logo.webp';
import github from '../../img/githubb.webp'

const Socials = () => {
    return (
        <>
            <div className='flex flex-row gap-x-3'>
                <a href="/404" target='_blank'><img src={linkedin} alt="linkedin-logo" className='h-5 md:h-7 hover:scale-110 duration-200 border border-white rounded-full' /></a>
                <a href="/404" target='_blank'><img src={github} alt="github-logo" className='h-5 md:h-7 hover:scale-110 duration-200 border border-white rounded-full bg-white' /></a>
                <a href="/404" target='_blank'><img src={instagram} alt="instagram-logo" className='h-5 md:h-7 hover:scale-110 duration-200 border border-white rounded-full' /></a>
                <a href="/404" target='_blank'><img src={tiktok} alt="tiktok-logo" className='h-5 md:h-7 hover:scale-110 duration-200 border border-white rounded-full' /></a>
                <a href="/404" target='_blank'><img src={facebook} alt="faceboook-logo" className='h-5 md:h-7 hover:scale-110 duration-200 border border-white rounded-full' /></a>
            </div>
        </>
    );
}

export default Socials;